import React, { useState, useEffect } from 'react';
import {
  Popup,
  List,
  Avatar,
  Tag,
  Button,
  Space,
  Toast,
  SpinLoading,
  Card,
  Divider,
  Tabs
} from 'antd-mobile';

import {
  message
} from 'antd';

import { 
  CloseOutline, 
  UserOutline, 
  CalendarOutline,
  IdcardOutline,
  CheckCircleOutline,
  CloseCircleOutline,
  ScanOutline
} from 'antd-mobile-icons';

import {
  ExclamationCircleOutlined, FilterOutlined,  IdcardOutlined,ScanOutlined,
  DeleteOutlined,LoadingOutlined ,
  SearchOutlined,
  CalendarOutlined,
  UserOutlined,
  HomeOutlined,  
} from '@ant-design/icons';

import axios from 'axios';
import { BASE_URL } from '../utils/constants';
import ParticularModal from './ParticularModal';
import dayjs from 'dayjs';
import LectorDNIMobile from './LectorDNIMobile'; // Importar el lector DNI

const ModalOcupantesMovil = ({ visible, onClose, numReserva, linea, numHabitacion, nombreCliente, codigoHotel }) => {
  const [ocupantes, setOcupantes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lectorVisible, setLectorVisible] = useState(false);
  const [ocupanteSeleccionado, setOcupanteSeleccionado] = useState(null);
  const [lineaSeleccionada, setLineaSeleccionada] = useState(null);
  const [particularModalVisible, setParticularModalVisible] = useState(false);

  const [particularData, setParticularData] = useState({
    codParti: null,
    nombre: '',
    telefono: '',
    email: '',
    fechaEntrada: null,
    linea: null,
    numOcupante: null
  });  

  const [resumen, setResumen] = useState({
    total: 0,
    conCheckin: 0,
    sinCheckin: 0,
    conDNI: 0
  });

  useEffect(() => {
    if (visible && numReserva && linea) {
      cargarOcupantes();
    }
  }, [visible, numReserva, linea]);

  // Cuando se guarda el particular correctamente
  const handleParticularGuardado = async (codParti, data) => {
    // console.log("✅ Particular guardado:", codParti, data);
    message.success(`Datos del ocupante actualizados correctamente`);
    
    // Recargar líneas para actualizar el estado
    await cargarOcupantes();
  };

  const cargarOcupantes = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/checkin-checkout/${numReserva}/lineas/${linea}/ocupantes`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // console.log(response.data.data);


      const data = response.data.data || [];
      setOcupantes(data);
      
      // Calcular resumen
      setResumen({
        total: data.length,
        conCheckin: data.filter(o => o.Entro === true || o.Entro === 1).length,
        sinCheckin: data.filter(o => o.Entro !== true && o.Entro !== 1).length,
        conDNI: data.filter(o => o.dniParticular && o.dniParticular !== '').length
      });


      
    } catch (error) {
      console.error('Error cargando ocupantes:', error);
      Toast.show({
        content: 'Error al cargar los ocupantes',
        icon: 'fail'
      });
    } finally {
      setLoading(false);
    }
  };

  // Abrir lector DNI para un ocupante específico
  const abrirLectorDNI = (ocupante) => {
    setOcupanteSeleccionado(ocupante);
    setLectorVisible(true);
  };

  // Callback cuando se procesa el DNI
  const handleDNIProcesado = async (data) => {
    Toast.show({
      content: `DNI registrado: ${data.numero_documento}`,
      icon: 'success',
      duration: 2000
    });
    
    setLectorVisible(false);
    setOcupanteSeleccionado(null);
    
    // Recargar ocupantes para mostrar el nuevo DNI
    await cargarOcupantes();
  };

  const abrirParticularModal = (record) => {
    // console.log("📝 Abriendo datos personales para:", record);
    
    setParticularData({
      codParti: record.CodParti || null,
      nombre: record.Nombre || '',
      telefono: record.Telefono1 || '',
      email: record.EMail || '',
      fechaEntrada: record.Entrada || null,
      linea: record.Linea,
      numOcupante: record.Numocupante || 1,
      numHabitacion: record.NumHab
    });
    
    setLineaSeleccionada(record);
    setParticularModalVisible(true);
  };

  // Formatear tipo de facturación
  const getTipoFacDesc = (tipoFac) => {
    const tipos = {
      'IN': 'Individual',
      'DO': 'Doble',
      'TR': 'Triple',
      'AD1': 'Adulto 1',
      'AD2': 'Adulto 2',
      'NI1': 'Niño 1',
      'NI2': 'Niño 2',
      'NIE': 'Niño Especial',
      'BB': 'Bebé'
    };
    return tipos[tipoFac] || tipoFac;
  };

  // Formatear tipo de habitación
  const getTipoHabDesc = (tipoHab) => {
    const tipos = {
      'IN': 'Individual',
      'DO': 'Doble',
      'TR': 'Triple',
      'CU': 'Cuádruple',
      'QU': 'Quíntuple'
    };
    return tipos[tipoHab] || tipoHab;
  };

  return (
    <>
      <Popup
        visible={visible}
        onMaskClick={onClose}
        position='bottom'
        bodyStyle={{ 
          height: '85vh', 
          borderRadius: '20px 20px 0 0',
          backgroundColor: '#f5f5f5'
        }}
      >
        <div style={{ 
          height: '100%', 
          display: 'flex', 
          flexDirection: 'column',
          overflow: 'hidden'
        }}>
          {/* Header */}
          <div style={{ 
            padding: '16px 20px',
            background: 'white',
            borderBottom: '1px solid #e5e5e5',
            borderRadius: '20px 20px 0 0',
            position: 'sticky',
            top: 0,
            zIndex: 10
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <h3 style={{ margin: 0 }}>👥 Ocupantes de la habitación</h3>
                <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                  Reserva #{numReserva} - Hab #{numHabitacion} - {nombreCliente || ''}
                </div>
              </div>
              <Button fill='none' onClick={onClose}>
                <CloseOutline fontSize={22} />
              </Button>
            </div>
          </div>

          {/* Contenido */}
          <div style={{ flex: 1, overflow: 'auto', padding: '12px' }}>
            {loading ? (
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <SpinLoading color='primary' />
                <div style={{ marginTop: 12, color: '#666' }}>Cargando ocupantes...</div>
              </div>
            ) : ocupantes.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <UserOutline fontSize={48} style={{ color: '#ccc' }} />
                <div style={{ marginTop: 12, color: '#999' }}>No hay ocupantes registrados</div>
              </div>
            ) : (
              <>
                {/* Tarjetas de resumen */}
                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: 'repeat(3, 1fr)', 
                  gap: 8,
                  marginBottom: 16
                }}>
                  <div style={{ 
                    background: 'white', 
                    borderRadius: 12, 
                    padding: '12px 8px', 
                    textAlign: 'center',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                  }}>
                    <div style={{ fontSize: 20, fontWeight: 'bold', color: '#1677ff' }}>{resumen.total}</div>
                    <div style={{ fontSize: 11, color: '#666' }}>Total</div>
                  </div>
                  <div style={{ 
                    background: 'white', 
                    borderRadius: 12, 
                    padding: '12px 8px', 
                    textAlign: 'center',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                  }}>
                    <div style={{ fontSize: 20, fontWeight: 'bold', color: '#52c41a' }}>{resumen.conCheckin}</div>
                    <div style={{ fontSize: 11, color: '#666' }}>Checkin ✔</div>
                  </div>
                  <div style={{ 
                    background: 'white', 
                    borderRadius: 12, 
                    padding: '12px 8px', 
                    textAlign: 'center',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                  }}>
                    <div style={{ fontSize: 20, fontWeight: 'bold', color: resumen.conDNI > 0 ? '#52c41a' : '#faad14' }}>
                      {resumen.conDNI}
                    </div>
                    <div style={{ fontSize: 11, color: '#666' }}>Con DNI</div>
                  </div>
                </div>

                {/* Lista de ocupantes */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {ocupantes.map((ocupante, idx) => (
                    <div
                      key={idx}
                      style={{
                        background: 'white',
                        borderRadius: 16,
                        padding: '14px',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                        borderLeft: `4px solid ${ocupante.Entro === 1 ? '#52c41a' : '#faad14'}`
                      }}
                    >
                      {/* Header del ocupante */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                        <Avatar
                          style={{
                            backgroundColor: ocupante.Entro === 1 ? '#52c41a' : '#faad14',
                            width: 44,
                            height: 44,
                            fontSize: 18,
                            fontWeight: 'bold'
                          }}
                        >
                          {ocupante.Numocupante}
                        </Avatar>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 'bold', fontSize: 16 }}>{ocupante.Nombre}</div>
                          <div style={{ fontSize: 12, color: '#666' }}>
                            {getTipoFacDesc(ocupante.TipoFac)}
                          </div>
                        </div>
                        <Tag color={ocupante.Entro ? 'success' : 'warning'}>
                          {ocupante.Entro ? 'Checkin ✔' : 'Pendiente'}
                        </Tag>
                      </div>

                      <Divider style={{ margin: '8px 0' }} />

                      {/* Detalles */}
                      <div style={{ fontSize: 13 }}>
                        {/* DNI con botón de lectura */}
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'space-between',
                          marginBottom: 8
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <IdcardOutlined fontSize={16} />
                            <span style={{ color: ocupante.dniParticular ? '#52c41a' : '#999' }}>
                              {ocupante.dniParticular ? `DNI Registrado` : 'DNI no registrado'}
                            </span>
                          </div>
                          
                          <Button
                              type="primary"
                              icon={<UserOutlined />}
                              size="small"
                              color={ocupante.DNI ? 'default' : 'primary'}                              
                              onClick={() => abrirParticularModal(ocupante)}
                            >
                              Datos
                          </Button>                          
                                                    
                          {/* Botón para leer/actualizar DNI */}
                          {/* <Button
                            size='small'
                            color={ocupante.DNI ? 'default' : 'primary'}
                            fill={ocupante.DNI ? 'outline' : 'solid'}
                            onClick={() => abrirLectorDNI(ocupante)}
                            style={{ fontSize: 12, padding: '4px 8px', height: 'auto' }}
                          >
                            <ScanOutlined fontSize={14} />
                            {ocupante.DNI ? 'Actualizar' : 'Leer DNI'}
                          </Button> */}
                        </div>

                        {/* Fechas */}
                        <div style={{ display: 'flex', gap: 16, marginBottom: 8, flexWrap: 'wrap' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <CalendarOutline fontSize={14} />
                            <span style={{ fontSize: 12 }}>
                              Entrada: {dayjs(ocupante.Entrada).format('DD/MM/YYYY')}
                            </span>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <CalendarOutlined fontSize={14} />
                            <span style={{ fontSize: 12 }}>
                              Salida: {dayjs(ocupante.Salida).format('DD/MM/YYYY')}
                            </span>
                          </div>
                        </div>

                        {/* Tipo Habitación y Régimen */}
                        <div style={{ 
                          display: 'flex', 
                          gap: 8,
                          flexWrap: 'wrap',
                          paddingTop: 8,
                          borderTop: '1px solid #f0f0f0'
                        }}>
                          <Tag color='cyan' size='small'>
                            {getTipoHabDesc(ocupante.TipoHab)}
                          </Tag>
                          <Tag color='purple' size='small'>
                            {ocupante.Regimen || 'N/A'}
                          </Tag>
                          {ocupante.SNumero && (
                            <Tag color='orange' size='small'>
                              Localizador: {ocupante.SNumero}
                            </Tag>
                          )}
                        </div>

                        {/* Checkout si aplica */}
                        {ocupante.Salio === 1 && (
                          <div style={{ 
                            marginTop: 8, 
                            padding: '4px 8px', 
                            background: '#f6ffed', 
                            borderRadius: 8,
                            fontSize: 12,
                            color: '#52c41a'
                          }}>
                            <CheckCircleOutline fontSize={12} /> Checkout realizado el {dayjs(ocupante.FechaSalio).format('DD/MM/YYYY HH:mm')}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </Popup>

      {/* Modal Lector DNI */}
      <LectorDNIMobile
        visible={lectorVisible}
        onClose={() => {
          setLectorVisible(false);
          setOcupanteSeleccionado(null);
        }}
        onSuccess={handleDNIProcesado}
        numReserva={numReserva}
        linea={linea}
        numOcupante={ocupanteSeleccionado?.Numocupante}
        nombreCliente={ocupanteSeleccionado?.Nombre}
        numHabitacion={numHabitacion}
      />

      <ParticularModal
        visible={particularModalVisible}
        onClose={() => {
          setParticularModalVisible(false);
          setLineaSeleccionada(null);
        }}
        onSuccess={handleParticularGuardado}
        codigoHotel={codigoHotel}
        numReserva={numReserva}
        numHabitacion={numHabitacion}
        linea={particularData.linea}
        numOcupante={particularData.numOcupante}
        codParti={particularData.codParti}
        nombreReserva={particularData.nombre}
        telefonoReserva={particularData.telefono}
        emailReserva={particularData.email}
        fechaEntrada={particularData.fechaEntrada}
        tipoReserva="Hotel"
      />      
    </>
  );
};

export default ModalOcupantesMovil;